import fetch from "../../core/fetch";
import showToaster from "../../helpers/showToaster";

async function submit(values, dispatch) {
  const query = `
    mutation manageHostEmailTemplateSetting(
        $beforeCheckInContent: String,
        $afterCheckInContent: String,
        $beforeCheckOutContent: String,
        $afterCheckOutContent: String,
        $beforeCheckInSubject: String,
        $afterCheckInSubject: String,
        $beforeCheckOutSubject: String,
        $afterCheckOutSubject: String,
        $isEnableBeforeCheckIn: Int,
        $dayBeforeCheckIn: Int,
        $isEnableAfterCheckIn: Int,
        $dayAfterCheckIn: Int,
        $isEnableBeforeCheckOut: Int,
        $dayBeforeCheckOut: Int,
        $isEnableAfterCheckOut: Int,
        $dayAfterCheckOut: Int,
        $isEnableAutomatedMail: Int,
        $timeBeforeCheckIn: String,
        $timeAfterCheckIn: String,
        $timeBeforeCheckOut: String,
        $timeAfterCheckOut: String
    ) {
        manageHostEmailTemplateSetting (
            beforeCheckInContent: $beforeCheckInContent,
            afterCheckInContent: $afterCheckInContent,
            beforeCheckOutContent: $beforeCheckOutContent,
            afterCheckOutContent: $afterCheckOutContent,
            isEnableBeforeCheckIn: $isEnableBeforeCheckIn,
            dayBeforeCheckIn: $dayBeforeCheckIn,
            isEnableAfterCheckIn: $isEnableAfterCheckIn,
            dayAfterCheckIn: $dayAfterCheckIn,
            isEnableBeforeCheckOut: $isEnableBeforeCheckOut,
            dayBeforeCheckOut: $dayBeforeCheckOut,
            isEnableAfterCheckOut: $isEnableAfterCheckOut,
            dayAfterCheckOut: $dayAfterCheckOut,
            timeBeforeCheckIn: $timeBeforeCheckIn,
            timeAfterCheckIn: $timeAfterCheckIn,
            timeBeforeCheckOut: $timeBeforeCheckOut,
            timeAfterCheckOut: $timeAfterCheckOut,
            isEnableAutomatedMail: $isEnableAutomatedMail,
            beforeCheckInSubject: $beforeCheckInSubject,
            afterCheckInSubject: $afterCheckInSubject,
            beforeCheckOutSubject: $beforeCheckOutSubject,
            afterCheckOutSubject: $afterCheckOutSubject,
        ) {
            status
        }
    }
  `;

  const resp = await fetch("/graphql", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query: query,
      variables: { 
        ...values,
        dayBeforeCheckIn: parseInt(values.dayBeforeCheckIn),
        dayAfterCheckIn: parseInt(values.dayAfterCheckIn),
        dayBeforeCheckOut: parseInt(values.dayBeforeCheckOut),
        dayAfterCheckOut: parseInt(values.dayAfterCheckOut),
        timeBeforeCheckIn: `${values.timeBeforeCheckIn} ${values.timeBeforeCheckInPeriod}`,
        timeAfterCheckIn: `${values.timeAfterCheckIn} ${values.timeAfterCheckInPeriod}`,
        timeBeforeCheckOut: `${values.timeBeforeCheckOut} ${values.timeBeforeCheckOutPeriod}`,
        timeAfterCheckOut: `${values.timeAfterCheckOut} ${values.timeAfterCheckOutPeriod}`,
      },
    }),
    credentials: "include",
  });

  const { data } = await resp.json();

  if (data.manageHostEmailTemplateSetting.status === "success") {
    showToaster({ messageId: "hostEmailTemplateSettingSuccess", toasterType: "success" });
  } else {
    showToaster({ messageId: "hostEmailTemplateSettingError", toasterType: "error" });
  }
}

export default submit;
